import React from 'react';
import cx from 'classnames';

import FeaturedBaseView from './FeaturedBaseView';

const FeaturedPageTitleView = (props) => {
  return (
    <FeaturedBaseView
      {...props}
      HeadingTag="h1"
      headerSize="big"
      className={cx('featured-page-title', props.className)}
    />
  );
};

export default FeaturedPageTitleView;
